import React, { Component } from 'react';
import {MDBNavLink} from 'mdbreact';
import './ItemList.css';
import CartColumns from "./CartColumns";
import EmptyCart from "./EmptyCart"
import {ProductConsumer} from '../../context';
import CartList from './CartList';
import CartTotals from './CartTotals'

class Cart extends Component {
    render() {
        return (
            <section>
                <div className="container">
                    <div className="d-flex flex-row">
                        <MDBNavLink to="../" className="p-0 m-0"><i class=" my-5 pt-2 pr-3 fas fa-arrow-left"></i></MDBNavLink>
                        <h1 className="field my-5">Cart</h1>
                    </div> 
                </div>
                <ProductConsumer>
                    {value =>{
                        const {cart} = value;
                        if(cart.length>0){
                            return(
                                <React.Fragment>
                                    <CartColumns/>
                                    <CartList value={value}/>
                                    <CartTotals value={value}/>
                                </React.Fragment>
                            );
                        }
                            else{
                                return <EmptyCart/>;
                            }
                        }}
                </ProductConsumer>
            </section>
        );
    }
}

export default Cart;